const colorType = [
  {
    value: 'black',
    label: 'Black',
  },
  {
    value: 'blue',
    label: 'Blue',
  },
  {
    value: 'brown',
    label: 'Brown',
  },
  {
    value: 'green',
    label: 'Green',
  },
  {
    value: 'orange',
    label: 'Orange',
  },
  {
    value: 'purple',
    label: 'Purple',
  },
  {
    value: 'red',
    label: 'Red',
  },
  {
    value: 'white',
    label: 'White',
  },
  {
    value: 'yellow',
    label: 'Yellow',
  },
  {
    value: 'gray',
    label: 'Gray',
  },
  {
    value: 'gold',
    label: 'Gold',
  },
  {
    value: 'silver',
    label: 'Silver',
  },
];

export default colorType;